import defaultAttributes from '../defaultAttributes';

const MousePointer = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3z' }],
    ['path', { d: 'M13 13l6 6' }],
  ],
];

export default MousePointer;
